import React from 'react';
import Detail from './Detail';
import Options from './Options';
import QueryFormatAndExamples from './QueryFormatAndExamples';
import SearchForApoHoloPairs from './SearchForApoHoloPairs';

const Home = (): React.JSX.Element => {
   return (
      <article className="md-content__inner md-typeset" style={{ paddingTop: 0 }}>
         <Detail />
         <SearchForApoHoloPairs />
         <QueryFormatAndExamples />
         <Options />
      </article>
   );
};

export default Home;
